<template>
  <div id="ht-wrap"></div>
</template>

<script>
  export default {
    name: "tempIndex",
    data(){
      return{
        dataModel: null,          //数据容器//公共方法属性
        graphView: null,           //2D
        g3d: null,
        dm: null,
      }
    },
    beforeCreate() {
      window.htUrl('temp3d');
    },
    mounted() {
      this.addGraphView()
    },
    methods:{
      addGraphView() {
        this.dataModel = new ht.DataModel();  // 数据容器
        this.graphView = new ht.graph.GraphView(this.dataModel); // 2d 绑定数据模型
        this.dm = this.graphView.dm();
        //graphView.addToDOM(this.$el);  //将元素加入到指定的dom 元素下，不指定加入到document.body 下
        let _this = this;
        this.g3d = new ht.graph3d.Graph3dView();         //3d
        this.g3d.addToDOM(document.getElementById('ht-wrap'));
        this.g3d.deserialize('scenes/mod.json', function (json, dm, g3d, datas) {
          // g3d.setEye(-1000, 420, 450);
          // g3d.setCenter(-15, 500, 51);//目标
        });
        /*this.graphView.deserialize('displays/demo/3D会议室/3D会议室.json', function (json, dm, g3d, datas) {
          let table1 = dm.getDataByTag('table1'), table2 = dm.getDataByTag('table2');

          _this.getStatus();
        });*/
        /*this.graphView.addToDOM(this.g3d.getView());
        this.graphView.mi(this.handleInteractive2d);
        // 禁止所有缩放
        this.graphView.setZoomable(false)*/
        // 左键可拖拽编辑图元，右键可改变视角方向，采用这样的方式一般会结合键盘w|s|a|d按键进行漫游操作
        // this.g3d.setMouseRoamable(false);

        ht.Default.graph3dViewMaxPhi=Math.PI //最大角度
        ht.Default.graph3dViewMinPhi=0 //最小角度
      },
    }
  }
</script>

<style scoped lang="scss">
  #ht-wrap {
    width: 100%;
    height: 100vh;
    position: relative;
  }
</style>
